module.exports = __webpack_public_path__ + "static/media/galerija_2017 (5).bb6b3003.jpg";